'use client';

import { FC } from 'react';

import { useAuthentication, UserGroups } from '@ravago/shared/authentication';
import { ElementProps } from '@ravago/shared/page-data/models/base';
import { NormalizedProduct } from '@ravago/shared/page-data/models/contentful-mapped';
import { ProductRecommendationBadgeNode } from '@ravago/shared/page-data/models/elements';
import { Badge } from '@ravago/shared/radiance/components/badge/components/Badge/Badge';
import { useTranslations } from '@ravago/shared/translations/client';

export const ProductRecommendationBadgeElement: FC<ElementProps<ProductRecommendationBadgeNode>> = ({ node, globals }) => {
   const translate = useTranslations();
   const { user } = useAuthentication();

   const product = globals.contentEntity as NormalizedProduct;

   if (!product) return null;

   const showBadge = () => {
      if (!globals.isConsumer) return true;

      if (!user) return false;

      return product.preferred && user.groups.includes(UserGroups.ravagoSalesRepresentative);
   };

   return (
      showBadge() && (
         <Badge leadingIcon="gem" variant={node.variant} size={node.size}>
            {translate('product.recommendation')}
         </Badge>
      )
   );
};
